export default {
  SET_STATE: "settings/SET_STATE",
  HIDE_SHOW_MUSIC: "settings/HIDE_SHOW_MUSIC",
  CREATE_NEW_ACHIEVEMENT: "settings/CREATE_NEW_ACHIEVEMENT",
  UPDATE_USER_DETAILS: "settings/UPDATE_USER_DETAILS",
  HIDE_SHOW_ACHIEVEMENT: "settings/HIDE_SHOW_ACHIEVEMENT",
  CONNECT_LINK: "settings/CONNECT_LINK",
  UPDATE_USER_INFOS: "settings/UPDATE_USER_INFOS",
};
